module.exports = __webpack_public_path__ + "img/signature_background_desktop.7c1efec.webp";